document.addEventListener('DOMContentLoaded', function() {
  const searchSections = document.querySelectorAll('.ds-inline-search-section-wrapper');
  
  // Funktion zum Scrollbar-Machen der Suchergebnisse
  function ensureStyle(el, styleString) {
    if (!el.style.cssText.includes(styleString)) {
      el.style.cssText += styleString;
    }
  }

  function makeSearchResultsScrollable() {
    const resultsContainers = document.querySelectorAll('.ds-predictive-search-results-container');

    resultsContainers.forEach(container => {
      if (container.style.display !== 'none') {

        // Hauptcontainer sollte keine Scrollbar haben
        ensureStyle(container, 'max-height: none !important; overflow: visible !important;');

        // Suchergebnisse sollten keine Scrollbar haben
        const resultsElement = container.querySelector('.ds-predictive-search-results');
        if (resultsElement) {
          ensureStyle(resultsElement, 'max-height: none !important; overflow: visible !important;');
        }

        // Nur der Scroll-Wrapper sollte scrollbar sein
        const scrollWrapper = container.querySelector('.ds-scroll-wrapper');
        if (scrollWrapper) {
          ensureStyle(scrollWrapper, 'max-height: 60vh !important; overflow-y: auto !important; -webkit-overflow-scrolling: touch !important;');
        }

        // Alle x-tabs Elemente anpassen
        const xTabs = container.querySelectorAll('x-tabs');
        xTabs.forEach(tab => {
          ensureStyle(tab, 'max-height: none !important; overflow: visible !important;');
        });

        // Shadow DOM-Elemente finden und anpassen
        const predictiveSearch = container.closest('.ds-inline-search-section-wrapper').querySelector('predictive-search');
        if (predictiveSearch && predictiveSearch.shadowRoot) {
          try {
            // Tab-Panels im Shadow DOM
            const tabPanels = predictiveSearch.shadowRoot.querySelector('[part="tab-panels"]');
            if (tabPanels) {
              ensureStyle(tabPanels, 'max-height: none !important; overflow: visible !important;');
            }

            // Alle Slots durchgehen
            const slots = predictiveSearch.shadowRoot.querySelectorAll('slot');
            slots.forEach(slot => {
              if (slot.name !== 'results') { // Nur nicht-Ergebnis-Slots anpassen
                const assignedNodes = slot.assignedNodes({flatten: true});
                assignedNodes.forEach(node => {
                  if (node.nodeType === 1) { // Element-Knoten
                    ensureStyle(node, 'max-height: none !important; overflow: visible !important;');
                  }
                });
              }
            });
          } catch (e) {
            console.error('[DS Search] Error accessing shadow DOM:', e);
          }
        }
      }
    });
  }

  searchSections.forEach((sectionWrapper, index) => {
    const predictiveSearchElement = sectionWrapper.querySelector('predictive-search[data-predictive-search]');
    if (!predictiveSearchElement) {
      return;
    }

    const sectionId = predictiveSearchElement.getAttribute('section-id');
    if (!sectionId) {
      console.error('[DS Search] section-id attribute not found.');
      return;
    }

    const searchInput = sectionWrapper.querySelector(`#SearchInput-${sectionId}`);
    const closeButton = sectionWrapper.querySelector(`#SearchCloseButton-${sectionId}`);
    const resultsContainer = sectionWrapper.querySelector(`#ResultsContainer-${sectionId}`);
    const panelScroller = sectionWrapper.closest('.panel__scroller');

    if (!searchInput || !closeButton || !resultsContainer) {
      console.error('[DS Search] Missing one or more required elements:', { searchInput, closeButton, resultsContainer });
      return;
    }
    
    // Initial versuchen, die Suchergebnisse scrollbar zu machen
    setTimeout(makeSearchResultsScrollable, 500);
    
    // Auch bei Fokus auf das Suchfeld die Scrollbarkeit sicherstellen
    searchInput.addEventListener('focus', function() {
      setTimeout(makeSearchResultsScrollable, 300);
    });

    function toggleCloseButtonVisibility() {
      if (searchInput.value.length > 0) {
        closeButton.style.display = '';
      } else {
        closeButton.style.display = 'none';
      }
    }

    searchInput.addEventListener('input', toggleCloseButtonVisibility);

    closeButton.addEventListener('click', function () {
      searchInput.value = '';
      const event = new Event('input', { bubbles: true, cancelable: true });
      searchInput.dispatchEvent(event);
      searchInput.focus();
      toggleCloseButtonVisibility();
      
      // Suchergebnisse ausblenden
      setResultsVisibility(false);
      
      // Auch das Slot-Element im Shadow DOM zurücksetzen, falls möglich
      if (predictiveSearchElement.shadowRoot) {
        const slotElement = predictiveSearchElement.shadowRoot.querySelector('slot');
        if (slotElement && slotElement.getAttribute('name') === 'results') {
          // Versuchen, den Slot zurückzusetzen
          try {
            // Leeren Input-Event auslösen, um die Suche zurückzusetzen
            const resetEvent = new CustomEvent('predictive-search:reset', { bubbles: true });
            predictiveSearchElement.dispatchEvent(resetEvent);
          } catch (e) {
            console.error('[DS Search] Error resetting search:', e);
          }
        }
      }
    });

    toggleCloseButtonVisibility();

    function setResultsVisibility(isVisible) {
      resultsContainer.style.display = isVisible ? 'flex' : 'none';
      panelScroller?.classList.toggle('ds-search-results-open', isVisible);
    }

    customElements.whenDefined('predictive-search').then(() => {
      if (predictiveSearchElement.shadowRoot) {
        const slotElement = predictiveSearchElement.shadowRoot.querySelector('slot');

        if (slotElement) {
          const handleSlotChange = () => {
            const currentSlotName = slotElement.getAttribute('name');
            if (currentSlotName === 'results' || currentSlotName === 'loading') {
              setResultsVisibility(true);
              // Wenn Ergebnisse angezeigt werden, scrollbar machen
              setTimeout(makeSearchResultsScrollable, 100);
            } else {
              setResultsVisibility(false);
            }
          };

          const slotObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.attributeName === 'name') {
                handleSlotChange();
              }
            });
          });

          slotObserver.observe(slotElement, { attributes: true });
          handleSlotChange(); // Initial check
          
          // Wenn die Suchergebnisse angezeigt werden, stelle sicher, dass sie scrollbar sind
          slotElement.addEventListener('slotchange', function() {
            setTimeout(makeSearchResultsScrollable, 100);
          });
          
        } else {
          console.error('[DS Search] Slot element NOT found in shadow root.');
        }
      } else {
        console.error('[DS Search] Shadow root NOT found on predictive-search element.');
      }
      
      // MutationObserver für die Suchergebnisse
      const resultsObserver = new MutationObserver(function(mutations) {
        setTimeout(makeSearchResultsScrollable, 100);
      });
      
      resultsObserver.observe(resultsContainer, {
        childList: true,
        subtree: true
      });
      
      // Auch auf Klick-Events reagieren
      document.addEventListener('click', function(event) {
        if (event.target.closest('.ds-inline-search-input-container') || 
            event.target.closest('.ds-predictive-search-results-container')) {
          setTimeout(makeSearchResultsScrollable, 100);
        }
      });
      
      // Regelmäßig prüfen und anwenden (für den Fall, dass andere Skripte die Styles überschreiben)
      setInterval(makeSearchResultsScrollable, 2000);
    });
  });
});
